"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FeLayout = _interopRequireDefault(require("./FeLayout"));

var _WithHeader = _interopRequireDefault(require("./WithHeader"));

var _SvgIcon = _interopRequireDefault(require("./SvgIcon"));

var _FeResult = _interopRequireDefault(require("./FeResult"));

var _Footers = _interopRequireDefault(require("./Footers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = [_FeLayout.default, _SvgIcon.default, _FeResult.default, _WithHeader.default, _Footers.default];

var install = function install(Vue) {
  components.forEach(function (component) {
    Vue.component(component.name, component);
  });
};

var _default = {
  version: '0.0.1',
  install: install,
  FeLayout: _FeLayout.default,
  SvgIcon: _SvgIcon.default,
  FeResult: _FeResult.default,
  WithHeader: _WithHeader.default,
  FeFooter: _Footers.default
};
exports.default = _default;